import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { AgentDetails } from "../../agentlist/components/AgentDetails";
import { ShareDialog } from "../../agentlist/components/ShareModal";
import * as actions from "../redux/SubAgentAction";
import { CreateSubAgentDialog } from "./CreateSubAgentDialog";
import "./subAgent.css";
import { UpdateSubAgentPermission } from "./UpdateSubAgentPermission";

export const SubAgentList = () => {
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const [agentId, setAgentId] = useState(null);
  const [agentDetailsVisible, setAgentDetailsVisible] = useState(false);
  const dispatch = useDispatch();
  const subAgentState = useSelector(({ subAgent }) => subAgent, shallowEqual);

  useEffect(() => {
    const queryParams = {
      action: "subagentlist",
    };
    dispatch(actions.callSubAgentList(queryParams));
  }, []);

  return (
    <div style={{ width: "95%", margin: "5px auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <AgentDetails
        selAgentId={agentId}
        isAgentDetailsVisible={agentDetailsVisible}
        agentSettingPermission="true"
        onClose={() => setAgentDetailsVisible(false)}
        isSubAgent={true}
      />
      <ShareDialog
        selAgentId={agentId}
        selMemberId={undefined}
        fromSide="subagent"
      />
      <UpdateSubAgentPermission setSwalProps={setSwalProps} agentId={agentId} />
      <CreateSubAgentDialog setSwalProps={setSwalProps} />
      <div>
        <h2>{intl.formatMessage({ id: "subAgentList" })}</h2>
      </div>
      <div
        className="buttonCss"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        {intl.formatMessage({ id: "addSubAgent" })}
        <button
          className="btn btn-primary buttonAdd"
          data-bs-toggle="modal"
          data-bs-target={`#addSubAgentModal`}
        >
          {intl.formatMessage({ id: "addSubAgent" })}
        </button>
      </div>
      <div
        className="d-flex"
        style={{
          overflowX: "auto",
          margin: "10px auto",
        }}
      >
        <div className="agent-container" style={{ overflowX: "auto" }}>
          <table className="agent-table">
            <thead className="agent-header">
              <tr className="agent-row">
                <th className="agent-cell hide-on-mobile col-1">
                  {intl.formatMessage({ id: "no" })}
                </th>
                <th className="agent-cell col-2 fixed-column">
                  {intl.formatMessage({ id: "username" })}
                </th>
                <th className="agent-cell col-2">
                  {intl.formatMessage({ id: "nickname" })}
                </th>
                <th className="agent-cell col-2">
                  {intl.formatMessage({ id: "share" })}
                </th>
                <th className="agent-cell col-2">
                  {intl.formatMessage({ id: "action" })}
                </th>
              </tr>
            </thead>
            <tbody className="agent-body">
              {subAgentState.subAgentLists &&
                subAgentState.subAgentLists.subAgentLists ? (
                subAgentState.subAgentLists.subAgentLists.length > 0 ? (
                  subAgentState.subAgentLists.subAgentLists.map(
                    (subagent, index) => (
                      <tr key={index} className="agent-row">
                        <td className="agent-cell hide-on-mobile col-1">
                          {index + 1}
                        </td>
                        <td className="agent-cell col-2 fixed-column">
                          {subagent.username}
                        </td>
                        <td className="agent-cell col-2">
                          {subagent.nickname}
                        </td>
                        <td className="agent-cell col-2">
                          <i
                            className="bi bi-share"
                            data-bs-toggle="modal"
                            data-bs-target={`#ShareModal`}
                            onClick={() => {
                              setAgentId(subagent.agentid);
                            }}
                          ></i>
                        </td>
                        <td className="agent-cell col-2 d-flex">
                          <button
                            className="btn btn-primary"
                            style={{ marginRight: "3px" }}
                            onClick={() => {
                              setAgentDetailsVisible(true)
                              setAgentId(subagent.agentid);
                            }}
                          >
                            <i className="bi bi-pen"></i>
                          </button>

                          <button
                            className="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target={`#updateSubAgentPermissionModal`}
                            style={{ marginLeft: "3px" }}
                            onClick={() => {
                              setAgentId(subagent.agentid);
                            }}
                          >
                            <i className="bi bi-gear"></i>
                          </button>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr className="oRecordDiv">
                    <td colSpan="6">
                      <div className="no-record-wrapper">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )
              ) : (
                <tr>
                  <td colSpan="6">
                    <Skeleton height="600px" className="w-100" />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
